"use client";

import { Prism as SyntaxHighlighterBase } from 'react-syntax-highlighter';
const SyntaxHighlighter = SyntaxHighlighterBase as any;
import { materialDark } from 'react-syntax-highlighter/dist/esm/styles/prism';

interface CodeBlockProps {
  code: string;
  language?: string;
}

export function CodeBlock({ code, language = "python" }: CodeBlockProps) {
  return (
    <SyntaxHighlighter
      language={language}
      style={materialDark}
      PreTag="pre"
      customStyle={{
        margin: 0,
        padding: '16px',
        background: '#09090b',
        fontSize: '13px',
        lineHeight: '1.6',
        fontFamily: 'ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, monospace',
        boxSizing: 'border-box',
        borderRadius: '0.5rem',
      }}
      codeTagProps={{
        style: {
          whiteSpace: 'pre-wrap',
          wordBreak: 'break-word',
          overflowWrap: 'anywhere',
          display: 'block',
        },
      }}
      showLineNumbers={false}
      wrapLines={false}
      wrapLongLines={true}
    >
      {code}
    </SyntaxHighlighter>
  );
}

